import { useQuery } from "@tanstack/react-query";
import { adminSearchService } from "../../../services/adminSearch";
import { useAdminSearchStore } from "../store/adminSearchStore";
import { buildFiltersPayload } from "../utils/filterPayloadBuilder";

export function useAdminSearchUsers() {
  const { usersState } = useAdminSearchStore();
  const { filters, pagination } = usersState;

  const queryKey = [
    "adminSearchUsers_key",
    {
      filters: {
        userInput: filters.userInput,
        subscriptionType: filters.subscriptionType,
        gender: filters.gender,
        dominantHand: filters.dominantHand,
        userCreated: filters.userCreated,
        secondarySubType: filters.secondarySubType,
        studentCredits: filters.studentCredits,
        reportCredits: filters.reportCredits,
      },
      page: pagination.page,
      limit: pagination.limit,
    },
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const filtersPayload = buildFiltersPayload(filters);
      const requestFilters = {
        ...filtersPayload,
        ...(filters.userInput?.trim()
          ? { userInput: filters.userInput.trim() }
          : {}),
        ...(Array.isArray(filters.subscriptionType) &&
        filters.subscriptionType.length > 0
          ? { subscriptionType: filters.subscriptionType }
          : {}),
      };

      const res = await adminSearchService.adminSearchUsers({
        page: pagination.page,
        limit: pagination.limit,
        filters: requestFilters,
      });
      return {
        users: res.users || [],
        total: res.total || 0,
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
